<template>
    <!-- menu -->
    <div>
        <div class="d-none d-md-block menubar">
            <!-- menu 父層 -->
            <ul class="nav menu justify-content-around screenWidth">
                <li class="nav-item text-center pt-1 mx-2"
                    v-for="(item, index) in menuList"
                    :key="index"
                    :class="{
                        reverse: !item.active,
                        'menu--active': item.active,
                    }"
                    @click="showMenuChild(item)">
                    <h2 class="active nav-link cursorPoint font-weight-bold"
                        :data-ga-element="`${gaData}${item.label}`">{{ item.label }}</h2>
                </li>
            </ul>
            <!-- menu子選 -->
            <transition enter-active-class="fade-enter-active"
                        leave-active-class="fade-leave-active">
                <div class="text-white menuChild"
                     v-if="showMenu">
                    <div class="screenWidth d-flex justify-content-start py-1">
                        <div class="d-inline-block py-2">
                            <span class="cursorPoint menuChild__title text-left d-block"
                                  :data-ga-element="`${gaData}${activeMenuItem.label}`"
                                  @click="goToCategoriesList(activeMenuItem.label)">
                                {{ activeMenuItem.label }}
                            </span>
                        </div>
                        <div class="d-inline-block py-2">
                            <ul class="nav menuChild__child pl-1">
                                <li class="nav-item"
                                    v-for="(child, index) in activeMenuItem.children"
                                    :key="index"
                                    :data-ga-element="`${gaData}${activeMenuItem.label}|${child.label}`"
                                    @click="goToCategoriesList(child.label)">
                                    <span class="cursorPoint px-4"
                                          :data-ga-element="`${gaData}${activeMenuItem.label}|${child.label}`">
                                        {{ child.label }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- 漢堡內容 -->
        <transition enter-active-class="left-enter-active"
                    leave-active-class="left-leave-active">
            <div v-if="isShowMenuBlock"
                 class="hamburgerBlock px-0">
                <div class="col-12 d-md-none pt-2 pb-1 px-2">
                    <XIcon class="cursorPoint"
                           size="2.25x"
                           stroke-width="1.5"
                           @click="closeMenuBlock()" />
                </div>
                <p class="w-100 px-3 pb-1 pt-2 text-white m-0 hamburgerBlock__title ">
                    主題分類
                </p>
                <div class="accordion"
                     id="accordionExample">
                    <div class="card border-0"
                         v-for="(item, index) in menuList"
                         :key="index">
                        <div class="card-header underline p-3"
                             id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn w-100 p-0 clearfix"
                                        type="button"
                                        data-toggle="collapse"
                                        :data-target="`#collapseOne${index}`"
                                        :data-ga-element="`${gaData}${item.label}`">
                                    <div class="d-flex justify-content-start align-items-center float-left w-75"
                                         @click="goToCategoriesList(item.label)"
                                         :data-ga-element="`${gaData}${item.label}`">
                                        <div class="rounded-circle d-flex align-items-center justify-content-center menuIcon">
                                            <img :src="item.imgUrl"
                                                 :alt="item.alt"
                                                 :data-ga-element="`${gaData}${item.label}`"/>
                                        </div>
                                        <span class="btn__sapn" :data-ga-element="`${gaData}${item.label}`">{{ item.label }}
                                        </span>
                                    </div>
                                    <div class=" float-right mt-1"
                                         @click="showMenuChild(item)">
                                        <ChevronDownIcon v-if="item.children.length > 0"
                                                         class="float-right "
                                                         size="1.75x"
                                                         stroke-width="1.5"
                                                         :class="{
                                                whirlIcon: item.active,
                                                whirlIcon2: !item.active,
                                            }" />
                                    </div>
                                </button>
                            </h2>
                        </div>

                        <div v-if="item.children.length > 0"
                             :id="`collapseOne${index}`"
                             class="collapse"
                             aria-labelledby="headingOne"
                             data-parent="#accordionExample">

                            <div class="card-body">
                                <h3 class="hamburgerBlock__child cursorPoint"
                                    v-for="(child, index) in item.children"
                                    :key="index"
                                    :data-ga-element="`${gaData}${item.label}|${child.label}`"
                                    @click="goToCategoriesList(child.label)">
                                    {{ child.label }}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { XIcon, ChevronDownIcon } from 'vue-feather-icons';

export default {
    name: 'Menu',
    components: { XIcon, ChevronDownIcon },
    props: {
        isShowMenuBlock: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            spaceName: '選單',
            activeMenuItem: {
                name: '旅遊',
                children: ['旅人味', '閱讀旅行', '旅遊3'],
            },
            showMenu: false,
        };
    },
    computed: {
        gaData() {
            return (
                this.systemName +
                '|' +
                this.spaceName +
                '|'
            );
        },
        menuList() {
            return this.$store.state.menuList;
        }
    },
    created() {
        // get api
    },
    mounted() {
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.showMenu = false;
                this.menuList.map((item) => {
                    item.active = false;
                });
            } else {
                // this.showMenu = true;
            }
        });
    },
    methods: {
        /* 分類清單 */
        goToCategoriesList(label) {
            this.showMenu = false;
            this.menuList.map((item) => {
                item.active = false;
            });
            this.closeMenuBlock();
            // this.$router.push({ name: '', params: { sort: value } }.catch(() => { }));
            this.$router.push({ name: 'categories', params: { page: 1, categories: label } }).catch(() => { });
        },
        showMenuChild(item) {
            if (item.children.length > 0) {
                this.showMenu = !item.active;
                this.menuList.map((item) => {
                    item.active = false;
                });
                item.active = this.showMenu;
                this.activeMenuItem = item;
            } else {
                this.showMenu = false;
                this.menuList.map((item) => {
                    item.active = false;
                });
                this.$router.push({ name: 'categories', params: { page: 1, categories: item.label } }).catch(() => { });
            }
        },
        closeMenuBlock() {
            this.$emit('closeMenuBlock');
        },
    },
};
</script>
<style lang="scss" scoped>
/// menubar
.menubar {
    height: 3rem;
    position: fixed;
    top: 58px;
    left: 0;
    width: 100%;
    z-index: 5;
    background-color: $primary;
}
.menu {
    color: $white;
    font-size: 19px;
    .nav-item {
        min-width: 5rem;
        height: 3rem;
        @include media-breakpoint-up(lg) {
            min-width: 7rem;
        }
    }
    .menu--active {
        background-color: $success;
        animation: colorchange 0.35s;
        animation-direction: normal;
    }
}
@keyframes colorchange {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.menuChild {
    margin-top: -1px;
    background-color: $success;
    .screenWidth {
        padding-left: 8%;
        @include media-breakpoint-up(xl) {
            padding-left: 95px;
        }
    }

    .menuChild__title {
        font-weight: bold;
        min-width: 3rem;
        margin-right: 2rem;
    }
    .menuChild__child {
        border-left: 1px solid $gray-300;
    }
}
.hamburgerBlock {
    width: 95%;
    max-width: 359px;
    height: 100vh;
    z-index: 20;
    position: fixed;
    top: 0;
    background-color: $white;
    box-shadow: 1px -1px 1px $gray-300;
    .accordion {
        overflow-y: auto;
        height: calc(100vh - 37px - 49px);
        padding-bottom: 3.5rem;
    }
    .underline {
        border-bottom: 2px solid $gray-300;
    }
    .hamburgerBlock__title {
        font-size: 1.125rem;
        background-color: $primary;
    }
    .hamburgerBlock__child {
        font-size: 1.125rem;
        line-height: 2.45;
        font-weight: normal;
        padding-left: 2.5rem;
    }
    .card-body {
        background-color: $secondary;
    }
    .btn__sapn {
        font-size: 1.25rem;
        vertical-align: bottom;
        margin-left: 0.65rem;
    }

    .card-header {
        background-color: $white;
        padding-top: 9px;
        padding-bottom: 9px;
    }

    .whirlIcon {
        transform: rotate(180deg);
        animation: rotateTo 0.3s;
    }
    .menuIcon {
        width: 36px;
        height: 36px;
        background-color: $secondary;
        img {
            max-width: 65%;
            max-height: 65%;
        }
    }
    .whirlIcon2 {
        animation: rotateTo2 0.3s;
    }

    @keyframes rotateTo {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(180deg);
        }
    }
    @keyframes rotateTo2 {
        0% {
            transform: rotate(180deg);
        }
        100% {
            transform: rotate(0);
        }
    }
    &.left-enter-active {
        animation: go-move 0.35s;
    }
    &.left-leave-active {
        animation: go-move 0.35s;
        animation-direction: reverse;
    }
    @keyframes go-move {
        0% {
            left: -1200px;
        }
        100% {
            left: 0;
        }
    }

    .fade-enter-active {
        animation: go-fade 0.35s;
    }

    .fade-leave-active {
        animation: reverse-fade 0.2s;
        animation-direction: reverse;
    }

    @keyframes go-fade {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
}
</style>
